"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApToggleSwitchGroup = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.ApToggleSwitchGroup = function (_a) {
    var flexDirection = _a.flexDirection, justifyContent = _a.justifyContent, className = _a.className, children = _a.children, props = __rest(_a, ["flexDirection", "justifyContent", "className", "children"]);
    var modifiedChildren = React.Children.map(children, function (child) {
        return React.cloneElement(child, {
            name: props.name,
            type: props.type
        });
    });
    return (React.createElement(styles_1.StyledToggleSwitchGroupFieldset, { className: "ap-toggle-switch-group " + (className ? className : '') },
        React.createElement(styles_1.StyledToggleSwitchGroupLegend, null, props.name),
        React.createElement(styles_1.StyledToggleSwitchGroup, { flexDirection: flexDirection, justifyContent: justifyContent }, modifiedChildren)));
};
exports.ApToggleSwitchGroup.defaultProps = {
    flexDirection: 'column'
};
//# sourceMappingURL=ApToggleSwitchGroup.js.map